// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TDeleteFromComparisonRequest,
  TDeleteFromComparisonModel,
  IMappers,
  TDeleteFromComparisonResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IDeleteFromComparisonResponse } from '../../entities/v1_delete_from_comparison/DeleteFromComparisonResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createDeleteFromComparisonModel(parameters: TDeleteFromComparisonRequest): TDeleteFromComparisonModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'property-comparison',
    pathApi: '/v1/delete-from-comparison/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IDeleteFromComparisonOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TDeleteFromComparisonRequest;
}

export async function fetchDeleteFromComparison<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IDeleteFromComparisonOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TDeleteFromComparisonResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createDeleteFromComparisonModel(parameters),
    config,
  )) as FetchResponse<TDeleteFromComparisonResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IDeleteFromComparisonResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TDeleteFromComparisonResponse>;
}
